/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Waypoint } from 'react-waypoint'
import { hot } from 'react-hot-loader/root'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import { Irma } from './images/irma'
import { Hansruedi } from './images/hansruedi'
import { Granit } from './images/granit'
import { Hans } from './images/hans'
import { Simone } from './images/simone'
import { Tabea } from './images/tabea'
import { Karin } from './images/karin'
import { Charlotte } from './images/charlotte'
import { Tina } from './images/tina'
import { Tilda } from './images/tilda'
import { Gerhard } from './images/gerhard'
import { Frieda } from './images/frieda'
import { Mirka } from './images/mirka'
import { Fritz } from './images/fritz'
import { Jana } from './images/jana'
import { Magdalena } from './images/magdalena'
import { Joerg } from './images/joerg'
import { Flurina } from './images/flurina'
import { Rosmarie } from './images/rosmarie'
import { Karl } from './images/karl'
import { Kurt } from './images/kurt'
import { Caroline } from './images/caroline'
import { SvgBlinker } from '../svgblinker'

const ARTICLE_ID = '356959265168'
const isMobile = window.innerWidth < 600

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      page: '0/22',
      counterHidden: true
    }
  }

  render() {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        <header className='ui vertical very fitted  segment'>
          <div className='ui container'>
            <div className='ui header'>
              <h1>«Dachte, das wird nicht so schlimm»</h1>
              <h2>
                Wie ist es, an Covid zu erkranken? Hier erzählen Leserinnen und
                Leser von ihren Erfahrungen.
              </h2>
            </div>
          </div>
        </header>

        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>
                <nobr>Linus Schöpfer</nobr>, <nobr>Mathias Lutz</nobr>
              </div>
              <div className='ta updated'>
                Aktualisiert am 12. Dezember 2020
              </div>
            </div>
            <div className='ta text'>
              <p>
                Jeden Tag reden und lesen wir über Corona. Trotzdem bleibt das
                Virus rätselhaft. Manche bemerken eine Infektion nie, andere
                erleben die Erkrankung als milde Grippe, wieder andere zwingt
                sie ins Spital oder gar in die künstliche Beatmung.
              </p>
              <p>
                Wir haben nach den Covid-Erfahrungen von erkrankten Leserinnen
                und Lesern gefragt. Hier sind die Antworten – von der Schülerin
                zum Rentner, vom Hauswart zur Wissenschaftlerin. 
              </p>
              <div className='hint'>
                <h5>Über die Umfrage</h5>
                <p>
                  Dieser Artikel ist das Ergebnis eines Leseraufrufs, der Mitte
                  November auf den Websites und in den Zeitungen der
                  Tamedia-Bezahlmedien veröffentlicht wurde. 
                </p>
                <p>
                  Die Beiträge der Leserinnen und Leser wurden anonymisiert. Das
                  heisst, Vor- und Nachname wurden geändert. Auch die
                  Illustrationen entsprechen nicht dem realen Äusseren der
                  Befragten.
                </p>
                <p>
                  Alle übrigen Angaben – Alter, Beruf und Wohnkanton – sind
                  authentisch. 
                </p>
              </div>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '1/22', counterHidden: false })
                }}
              />
              <Waypoint
                scrollableAncestor={window}
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ counterHidden: true })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Simone />} />
              </div>
              <p className='names'>
                <nobr>Simone Y. (16)</nobr>
              </p>
              <div className='info'>Schülerin, Kanton Zürich</div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Im Gymnasium tragen wir
                konsequent Masken. Wir essen allerdings zusammen. Eine Kollegin,
                mit der ich zu Mittag ass, wurde positiv getestet. Kurz darauf
                fiel auch mein Test positiv aus. Ich ging sofort in Quarantäne.
                Ich konnte kurzzeitig nichts mehr schmecken, hatte sonst aber
                keine Symptome. In der Isolation gings mir gut. Ich habe mit
                vielen Facetime gemacht und musste so nicht alleine Znacht
                essen. Von meiner Familie steckte sich niemand an, obwohl wir
                bis kurz vor meinem Test noch gemeinsam gegessen hatten. Das
                Contact-Tracing hat sich nie bei mir gemeldet.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '2/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Hansruedi />} />
              </div>
              <p className='names'>
                <nobr>Hansruedi K. (45)</nobr>
              </p>
              <div className='info'>Hauswart, Kanton St. Gallen</div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Ich erkrankte Anfang November.
                Ich hatte vier Tage Fieber und zwei Wochen lang Husten. Ich
                komme noch immer schnell ausser Atem und arbeite daher erst zu
                50 Prozent. Ich versuche, mein Gewicht zu reduzieren, und hoffe,
                dass sich meine Atmung dadurch wieder verbessert. Was mir
                psychisch am meisten zu schaffen macht, ist der
                Geschmacksverlust. Als Kochlehrer und leidenschaftlicher
                Hobbykoch habe ich grosse Angst davor, nie mehr richtig
                schmecken zu können.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '3/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Tabea />} />
              </div>
              <p className='names'>
                <nobr>Tabea V. (36)</nobr>
              </p>
              <div className='info'>Wissenschaftlerin, Kanton Bern</div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Ich infizierte mich Anfang
                Oktober mit Corona. Der Verlauf war milde. Etwas Husten und
                Fieber, Gliederschmerzen. Doch als diese Symptome weg waren,
                kamen neue hinzu: eine grosse Erschöpfung, Kurzatmigkeit,
                Kopfschmerzen und ein Tinnitus. Ich reagiere nun auch
                empfindlich auf Geräusche und Licht. Auch habe ich Mühe, mich zu
                konzentrieren, und bin vergesslich. Ich bin noch immer nicht zu
                100 Prozent arbeitsfähig.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '4/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Gerhard />} />
              </div>
              <p className='names'>
                <nobr>Gerhard Z. (50)</nobr>
              </p>
              <div className='info'>Bankangestellter, Kanton Zürich</div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Ich hatte einen Herzinfarkt,
                gehöre also zur Risikogruppe. Es begann Mitte November mit
                Übelkeit und Husten, dann bekam ich Fieber. Ich hatte
                fürchterlich kalt und Schüttelfrost. Nach drei Tagen war das
                Fieber weg, aber auch der Geschmackssinn. Der Test fiel dann
                positiv aus. Das war eine Befreiung, weil ich nun wusste, was
                ich hatte. Aber es war auch ein Schock: Was würde jetzt noch
                kommen? Es ging dann aber rasch besser, die Symptome
                verschwanden. Ich blieb aber noch länger schlapp. Was mich
                beschäftigte: dass man mit der Krankheit ziemlich allein ist.
                Auch der Hausarzt war nur mässig an mir interessiert.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '5/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Granit />} />
              </div>
              <p className='names'>
                <nobr>Granit P. (32)</nobr>
              </p>
              <div className='info'>Ingenieur, Kanton Basel-Stadt</div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Vielleicht habe ich mich auf
                einer längeren Autofahrt mit einem Freund angesteckt. Dann:
                Kopfschmerzen, Gliederschmerzen, leichter Husten. Schmerzen am
                ganzen Rücken. Die Kopfschmerzen wurden stärker, und ich wurde
                müder. Mein Geruchs- und Geschmackssinn fiel eine Woche aus.
                Leider steckte ich meinen Vater und meinen Bruder an. Corona war
                für mich definitiv schlimmer als eine normale Grippe.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '6/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Hans />} />
              </div>
              <p className='names'>
                <nobr>Hans Z. (61)</nobr>
              </p>
              <div className='info'>Informatiker, Kanton Zürich </div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Ich habe mich irgendwo in
                Südfrankreich infiziert, wo ich in den Ferien war. Am Ende der
                Ferien erhielt ich das positive Resultat. Ich hatte zwei Tage
                Fieber, Gliederschmerzen und Husten. Nach drei Tagen war ich
                wieder fit. Etwas länger dauerte es, bis der Geschmackssinn
                wieder zurück war, das waren ein paar Wochen. Corona war für
                mich letztlich wie eine leichte Grippe.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '7/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Tilda />} />
              </div>
              <p className='names'>
                <nobr>Tilda R. (40)</nobr>
              </p>
              <div className='info'>Lehrerin, Kanton Aargau</div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Als ich mich in Quarantäne
                begeben musste, wusste ich um meine Privilegien: ein grosses
                Haus und kaum Symptome. Nur ein komischer, neuer Husten und
                erhöhte Temperatur. Mein Mann besorgt den Haushalt. Ich schreibe
                Zusammenfassungen für den mittleren Sohn und lerne mit ihm über
                Facetime. Ich esse mit meiner Familie über Facetime, lese vor
                über Facetime, leite sie zum Kochen an über Facetime. Ich
                schlafe aus, bade, lese Krimis und Zeitung, schaue Netflix auf
                dem Stepper und telefoniere mit Familie und Freunden. Ich muss
                weder putzen noch waschen oder kochen. Corona ist für mich eine
                Alltagsauszeit. Die Springerin kann in der Schule viele meiner
                Stunden übernehmen. Ich bereite ihr alles vor. Nach mir
                erkrankten zwei weitere Lehrpersonen, eine ganze Klasse musste
                in Quarantäne. Die Zahl der angesteckten Schülerinnen und
                Schüler steigt. Die Klassenzimmer sind zu klein, die Fenster
                ständig offen.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '8/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Tina />} />
              </div>
              <p className='names'>
                <nobr>Tina Q. (57)</nobr>
              </p>
              <div className='info'>
                Mitarbeiterin einer Kulturinstitution,
                <br />
                Kanton Luzern
              </div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Ich holte mir Covid Ende März.
                Bei der Arbeit hatte ich an einem Donnerstag Wallungen, fühlte
                mich leicht krank. Ich ging nach Hause. Am Abend bekam ich
                Fieber, das drei Tage anhielt. In dieser Zeit hatte ich extreme
                Muskelschmerzen – so, als würde jeder einzelne Muskel schmerzen.
                Am Montag fühlte ich mich wieder gesund. Danach kam ich noch
                zwei, drei Wochen jeweils rasch ausser Atem, sogar beim
                Spazieren. Mein Partner hat sich übrigens nicht angesteckt.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '9/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Charlotte />} />
              </div>
              <p className='names'>
                <nobr>Charlotte F. (71)</nobr>
              </p>
              <div className='info'>
                Literaturwissenschaftlerin, Kanton Zürich 
              </div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Ich trainiere täglich eine halbe
                Stunde auf dem Crosstrainer und gehe zweimal die Woche ins
                Fitness. Mitte Oktober bekam ich Schmerzen beim Hüsteln und
                liess mich darauf bei der Hausärztin auf Corona testen. Das
                positive Resultat überraschte mich. Die Krankheit nahm dann
                einen milden Verlauf. Ausser diesem Kratzen und einem Tag
                Kopfschmerzen hatte ich keine Symptome. Ich konnte sogar mein
                tägliches Training auf dem Crosstrainer durchziehen.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '10/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Irma />} />
              </div>
              <p className='names'>
                <nobr>Irma Z. (54)</nobr>
              </p>
              <div className='info'>Chefin eines KMU, Kanton Zürich </div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Ich erkrankte Anfang Oktober. Ich
                entwickelte vor allem eine starke Müdigkeit und einen Schwindel,
                der mir auch psychisch zusetzte. Topfit fühle ich mich bis heute
                nicht, und mein Geruchssinn ist ebenfalls noch nicht komplett
                zurück. Ich nahm Corona immer ernst. Im Betrieb passten wir
                bereits ab Januar gut auf, und seit Ostern gilt bei uns
                Maskenpflicht. Ich hätte nie gedacht, dass es mich erwischt.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '11/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Frieda />} />
              </div>
              <p className='names'>
                <nobr>Frieda Y. (74)</nobr>
              </p>
              <div className='info'>Rentnerin, Kanton Aargau</div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Eine Bekannte steckte mich und
                meinen Mann bei einem Treffen an. Sie wusste nicht, dass sie
                Corona hatte. Drei Tage danach bekamen wir starken Husten und
                Schnupfen. Wir begaben uns sofort in Isolation und haben meines
                Wissens auch niemanden angesteckt. Corona verlief dann wie eine
                Grippe: Husten, Schnupfen, Halsweh, aber kein Fieber und auch
                keine Atemnot. Wir fühlten uns drei Wochen lang müder als sonst,
                aber das ist nun auch fast vorbei. Wir hatten ein Riesenglück!
                Das Contact-Tracing funktionierte übrigens bei uns, wir fühlten
                uns gut unterstützt.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '12/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Mirka />} />
              </div>
              <p className='names'>
                <nobr>Mirka W. (51)</nobr>
              </p>
              <div className='info'>Unternehmerin, Kanton Zürich </div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Ich dachte, als gesunde Frau wird
                das nicht so schlimm. Es kam dann anders. Mein 23-jähriger Sohn
                war positiv, bei ihm steckte ich mich Ende Oktober
                höchstwahrscheinlich an. Verlauf: Husten, Gliederschmerzen. Dann
                der positive Test. Dann begannen die Nieren zu schmerzen. Ich
                war so schlapp wie noch nie in meinem Leben. Der Weg in die
                Küche fühlte sich an wie eine Weltreise. Die Woche nach dem
                positiven Resultat war schrecklich. Dann ging es langsam
                aufwärts, ich ging spazieren wie eine alte Dame. Jetzt habe ich
                nur noch diese Müdigkeitssymptome, und mein Magen schmerzt ab
                und zu.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '13/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Fritz />} />
              </div>
              <p className='names'>
                <nobr>Fritz Y. (61)</nobr>
              </p>
              <div className='info'>Klavierlehrer, Kanton Zürich </div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Ich wollte in den Herbstferien
                eine Schiffsreise unternehmen. Bevor ich in Hamburg an Bord
                ging, musste ich einen Test machen. Resultat: positiv. Dann war
                ich sieben Tage beschwerdefrei, dann drei Tage Husten, einer
                davon ordentlich stark. Mit dem Asthmamittel Symbicort und dem
                Fiebersenker Ibuprofen kam ich letztlich aber gut über die
                Runden.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '14/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Karin />} />
              </div>
              <p className='names'>
                <nobr>Karin C. (42)</nobr>
              </p>
              <div className='info'>Lehrerin, Kanton Aargau</div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Als Lehrerin war mir klar, dass
                ich es mir irgendwann holen würde. Ich infizierte mich dann
                bereits im März. Ich hatte Husten und leichtes Fieber. Ohne die
                ganze Aufregung um Corona wäre ich wohl zur Arbeit gegangen.
                Mühsam war allerdings der Geschmacksverlust, der zwei Monate
                anhielt, jetzt aber zum Glück wieder weg ist.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '15/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Jana />} />
              </div>
              <p className='names'>
                <nobr>Jana Z. (47)</nobr>
              </p>
              <div className='info'>Kommunikationsfachfrau, Kanton Zürich</div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Als ich mich mit Corona
                infizierte, war ich kerngesund. Dann lag ich zwei Wochen flach
                mit Fieber und Symptomen, die sich täglich abwechselten:
                Heiserkeit, Verlust des Geschmacks- und Geruchssinns, Tinnitus,
                Husten, Kopfschmerzen. Und Gehirnnebel – «Brain Fog» – war für
                mich eine schlimme Erfahrung. Danach ging es langsam aufwärts.
                Aber bis heute fühle ich mich mental verlangsamt, und der
                Tinnitus wird mir wohl als Andenken an diese Krankheit bleiben.
                Was aber auch bleibt: Dankbarkeit für unser Gesundheitssystem,
                das uns jederzeit medizinische Versorgung garantiert – und Wut
                auf Covid-Egoisten und -Leugner, die die Pandemiebewältigung
                behindern. »
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '16/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Magdalena />} />
              </div>
              <p className='names'>
                <nobr>Magdalena W. (72)</nobr>
              </p>
              <div className='info'>Rentnerin, Kanton Zürich</div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Normalerweise ging ich jede Woche
                wandern und schwimmen. Dann auf einmal ein trockener Husten,
                kurz darauf starke Kopfschmerzen. Der Test fiel dann positiv
                aus. Der Husten war sehr lästig, vor allem in der Nacht, und ich
                fühlte mich sogar zum Lesen zu schlapp. Nach einem Monat fühle
                ich mich nun fast wieder gesund, auch der Appetit kommt langsam
                zurück. Die Betreuung durch die Hausärztin war gut. Ärgerlich
                war allerdings, dass ein Nachbar im Haus einen Zettel aufhängte
                mit den Hinweis, ich sei positiv getestet worden – ohne das
                vorher mit mir abzusprechen.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '17/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Joerg />} />
              </div>
              <p className='names'>
                <nobr>Jörg V. (72)</nobr>
              </p>
              <div className='info'>Rentner, Kanton Bern </div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Es begann Ende Oktober: Halsweh,
                leichter Husten. Ich dachte an eine gewöhnliche Erkältung und
                griff zu den bei mir bewährten Gegenmitteln:
                Eukalyptus-Dampfinhalationen, Neocitran, warme Umschläge um den
                Hals. Dann der Anruf eines befreundeten Paars, das meine Frau
                und mich besucht hatte: Es war positiv. Wir machten den Test –
                und waren ebenfalls positiv. Als ich dann auch den Geruchssinn
                verlor, überraschte mich das nicht mehr gross. Die Fernsehbilder
                aus den Intensivstationen waren dann schon belastend. Aber wir
                wussten, dass sich nach einer Woche abzeichnet, wie die
                Krankheit verläuft. Gott sei Dank verschlimmerte sich die
                Krankheit nicht, und es kamen auch keine Symptome dazu. Nach
                einer Woche war dann auch die Müdigkeit weg, und mit der Zeit
                kam auch der Geruchssinn zurück. Wir hoffen natürlich, jetzt
                immun zu sein. Ich werde mich aber so oder so impfen lassen. Ich
                fühlte mich während der Krankheit gut betreut, das
                Contact-Tracing funktionierte ebenfalls einwandfrei.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '18/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Flurina />} />
              </div>
              <p className='names'>
                <nobr>Flurina C. (41)</nobr>
              </p>
              <div className='info'>Bankangestellte, Kanton Zürich </div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Unsere Familie steckte sich
                bereits im Februar an. Wir waren in den Skiferien in Südtirol.
                Erst erkrankte der Sohn, dann mein Mann. Drei Wochen später war
                ich dran. Hohes Fieber während zweier Tage, fünf Tage später war
                der Geschmacks- und Geruchssinn weg. Damals wusste man noch
                nicht, dass das typisch ist für Corona. Wochen später litt ich
                zudem an Haarausfall, zudem bekam ich Schwierigkeiten mit dem
                Kurzzeitgedächtnis. Dieses Problem habe ich bis heute.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '19/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Rosmarie />} />
              </div>
              <p className='names'>
                <nobr>Rosmarie Q. (76)</nobr>
              </p>
              <div className='info'>Rentnerin, Kanton Aargau</div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Ich steckte mich auf einer
                Fahrradtour an. Erste Symptome: Schwindelgefühle, Durchfall,
                Appetitlosigkeit. Obwohl alles für eine Corona-Infektion sprach,
                war erst mein dritter Test positiv. Ich verlor zu Hause mehrmals
                das Bewusstsein, litt an Herzrasen. Wegen der Atemnot musste ich
                schliesslich vier Tage auf die Covid-Abteilung des Spitals
                Baden. Beruhigend war, dass kontinuierlich die Sauerstoffwerte
                gemessen wurden. Nun sind die Entzündungswerte wieder im
                normalen Bereich. Ich war nun zwei Monate krank, aber langsam
                kommt die Kraft zurück.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '20/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Karl />} />
              </div>
              <p className='names'>
                <nobr>Karl X. (40)</nobr>
              </p>
              <div className='info'>Manager, Kanton Zürich</div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Die Corona-Erkrankung war für
                mich ein verwirrendes Erlebnis. Anfang November hatte ich ganz
                wenig Fieber und etwas Halsschmerzen – milde Symptome also. Ich
                machte trotzdem einen Test, der negativ ausfiel. Dann musste ich
                mich vor einer Geschäftsreise nochmals testen lassen. Das
                Resultat: positiv. Ich war irritiert, weil ich zu diesem
                Zeitpunkt überhaupt keine Symptome mehr hatte. Ich musste in
                Quarantäne, liess mich am Tag darauf nochmals testen: negativ.
                Das Contact-Tracing hat sich nie bei mir gemeldet, und den Code
                für die Covid-App bekam ich erst drei Tage nach dem positiven
                Resultat.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '21/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Kurt />} />
              </div>
              <p className='names'>
                <nobr>Kurt V. (65)</nobr>
              </p>
              <div className='info'>Lehrer, Kanton Bern</div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Als Corona real wurde, traf ich
                alle nötigen Massnahmen. Ich traf mich kaum noch mit Freunden,
                trug Maske, konzentrierte mich aufs Homeoffice. Just am 3.
                November, als Trump abgewählt wurde, wurde Corona in unserer
                Familie zum Ernstfall. Meine Frau und mehrere Kolleginnen hatten
                sich bei einer Patientin angesteckt. Sie wurde positiv getestet.
                Kurz darauf musste ich sie in den Notfall bringen – sie ist
                Asthmatikerin und bekam Atemnot. Bald musste ich mich ebenfalls
                ins Spital begeben. Ich brauchte Sauerstoff. Nach einer Woche
                konnte ich nach Hause. Es blieben schwer erträgliche
                Kopfschmerzen, Appetitlosigkeit, Schlaflosigkeit im Wechsel mit
                Albträumen, Erschöpfung tagsüber. Ich habe in den letzten Wochen
                zehn Kilo verloren. Nun geht es langsam wieder aufwärts.»
              </p>
            </div>
          </div>

          <div className='ui text protocol container'>
            <div className='ta text'>
              <Waypoint
                scrollableAncestor={window}
                bottomOffset='400px'
                onEnter={({ previousPosition, currentPosition, event }) => {
                  this.setState({ page: '22/22', counterHidden: false })
                }}
              />

              <div className='svg-wrapper'>
                <SvgBlinker illu={<Caroline />} />
              </div>
              <p className='names'>
                <nobr>Caroline T. (58)</nobr>
              </p>
              <div className='info'>Intensivpflegefachfrau, Kanton Zürich</div>
              <div className='hr-theme-slash-2'>
                <div className='hr-line' />
                <div className='hr-icon'>
                  <img src={require('./images/virus.svg')} />
                </div>
                <div className='hr-line' />
              </div>
              <p>
                <span className='mark'>«</span>Es begann Mitte Oktober mit etwas
                Kopfschmerzen und einer laufenden Nase bei meinem Mann. Dann kam
                Fieber dazu. Wir machten beide den Test: positiv. Die Bilder in
                den Nachrichten setzten ein beunruhigendes Kopfkino in Gang.
                Sehr wahrscheinlich haben uns deutsche Bekannte angesteckt, die
                bei uns zu Besuch waren und kurz darauf erkrankten. Das
                Contact-Tracing meldete sich erst eine Woche nach dem Test.
                Dann waren die Schmerzen auch schon fast wieder weg. Der
                Geruchssinn ist allerdings bis heute nicht komplett zurück.»
              </p>
            </div>
          </div>

          <Waypoint
            scrollableAncestor={window}
            onEnter={({ previousPosition, currentPosition, event }) => {
              this.setState({ counterHidden: true })
            }}
          />

          <div
            className='page-count'
            style={{ opacity: this.state.counterHidden ? '0' : '0.85' }}
          >
            <i className='clone outline icon' /> {this.state.page}
          </div>
        </div>

        <Footer
          articleId={ARTICLE_ID}
          questions={[
            'Wie informativ war der Beitrag?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            ['Sammlung der Texte', 'Linus Schöpfer'],
            ['Umsetzung', 'Mathias Lutz']
          ]}
        >
          <div
            className='ui container'
            style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
          >
            <h4 className='teaser'>Weitere Beiträge zum Thema</h4>
            <ArticleTeasers
              numberOfCards='three'
              articleIds={['921118466582']}
            />
          </div>
        </Footer>
      </div>
    )
  }
}

export default hot('AppComponent')
